import React from 'react';
import "./styles/loading.css";

export default function Loading({fadeOut}) {
    return (
        <div className={`loader-container ${fadeOut ? "fade-out" : ""}`}>
            <div className="spinner">
            </div>
        </div>
    )
}